function PageHeader(el) {
    this.el = el;
    this.videoEl = this.el.querySelector('.jsPageHeaderVideo');

    if (this.videoEl) this.initVideo();
}

PageHeader.prototype.initVideo = function() {
    this.videoAspectRatio = this.videoEl.dataset.aspectRatio.split(':');

    this._setVideoSize();
    window.addEventListener('resize', _ => this._setVideoSize());
    window.addEventListener('orientationchange', _ => this._setVideoSize());
};

PageHeader.prototype._setVideoSize = function() {
    this.videoEl.style.width = null;
    this.videoEl.style.height = null;

    let newWidth = window.innerWidth;
    let newHeight = (this.videoEl.offsetWidth / this.videoAspectRatio[0]) * this.videoAspectRatio[1];

    if (newHeight < this.el.offsetHeight) {
        newHeight = this.el.offsetHeight;
        newWidth = (this.el.offsetHeight / this.videoAspectRatio[1]) * this.videoAspectRatio[0];
    }

    this.videoEl.style.width = newWidth + 'px';
    this.videoEl.style.height = newHeight + 'px';
};

(function () {
    const pageHeaderEl = document.querySelector('.jsPageHeader');
    if (pageHeaderEl) new PageHeader(pageHeaderEl);
})();